import Header from "Header";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import { Outlet, useLocation } from "react-router-dom";

/** `inApp`: the signed-in app's pages, as opposed to the public ones. */
export default function MainLayout({ inApp = false }: { inApp?: boolean }) {
  const { pathname } = useLocation();

  return (
    <>
      <Header />
      <Navbar inApp={inApp} />
      {/* Renders whatever child route is active. Keyed by the path, so
          opening another person on the same profile route starts afresh. */}
      <Outlet key={pathname} />
      <Footer />
    </>
  );
}
